window.addEventListener('load', function() { 
    const viewAllButton = document.querySelector('.view-all-images');
    const body = document.querySelector('body');
    const modal = document.createElement('div');
    modal.className = 'image-gallery-modal';
    modal.style.display = 'none'; 
    body.appendChild(modal);

    const leftButton = document.createElement('button');
    const rightButton = document.createElement('button');
    leftButton.innerText = '<';
    rightButton.innerText = '>';
    leftButton.style.cssText = rightButton.style.cssText = "position: absolute; top: 50%; transform: translateY(-50%); background-color: rgba(0, 0, 0, 0.8); color: white; border: none; padding: 10px 20px; cursor: pointer; font-size: 24px;";
    leftButton.style.left = '10px';
    rightButton.style.right = '10px';

    modal.appendChild(leftButton);
    modal.appendChild(rightButton);

    const closeButton = document.createElement('button');
    closeButton.innerText = 'Close';
    closeButton.style.cssText = "position: absolute; top: 20px; right: 20px; padding: 10px 20px; font-size: 16px; color: #fff; background: rgba(0, 0, 0, 0.8); border: none; cursor: pointer; border-radius: 5px; z-index: 1001;";
    closeButton.onclick = function() {
        modal.style.display = 'none';
        body.style.overflow = 'auto';
    };
    modal.appendChild(closeButton);

    let currentIndex = 0;

    function updateImageDisplay(index) {
        const images = modal.querySelectorAll('img');
        images.forEach((img, idx) => {
            img.style.display = idx === index ? 'block' : 'none';
        });
        currentIndex = index;
    }

    leftButton.onclick = function() {
        if (currentIndex > 0) {
            updateImageDisplay(currentIndex - 1);
        }
    };

    rightButton.onclick = function() {
        if (currentIndex < modal.querySelectorAll('img').length - 1) {
            updateImageDisplay(currentIndex + 1);
        }
    };

    function openGallery(initialIndex = 0) {
        const galleryImages = Array.from(document.querySelectorAll('.product-image-gallery img'));

        modal.style.display = 'flex';
        body.style.overflow = 'hidden';

        while (modal.querySelectorAll('img').length > 0) {
            modal.removeChild(modal.querySelector('img'));
        }

        galleryImages.forEach((image, index) => {
            const img = document.createElement('img');
            img.src = image.src;
            img.alt = image.alt;
            img.style.cssText = "max-width: 80%; max-height: 80%; margin: auto; display: none; border-radius: 8px;";
            
            img.onload = function() {
                modal.appendChild(img);
                if (index === initialIndex) {
                    updateImageDisplay(initialIndex);
                }
            };

            img.onerror = function() {
                console.error(`Failed to load image ${index + 1}: ${image.src}`);
            };
        });
    }

    const previewImages = document.querySelectorAll('.product-image-gallery img');
    previewImages.forEach((image, index) => {
        if (index < 5) {
            image.addEventListener('click', function() {
                openGallery(index);  // Pass the index of the clicked image
            });
        }
    });

    viewAllButton.addEventListener('click', function() {
        openGallery(0);  // Open gallery starting from the first image
    });
});

const style = document.createElement('style');
style.innerHTML = 
    `.image-gallery-modal {
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.9);
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 100000;
        overflow-y: hidden;
        overflow-x: hidden;
    }`;
document.head.appendChild(style);
